<report-page [footer]="footer" class="{{orientation}}">
	<ng-content>
	</ng-content>
	<ng-container *ngIf="!footer" ngProjectAs=".report-custom-footer">
		<ng-content select=".report-custom-footer"></ng-content>
	</ng-container>
</report-page>
